import { render, staticRenderFns } from "./textEditTool.vue?vue&type=template&id=4e3b4ff4"
import script from "./textEditTool.vue?vue&type=script&lang=js"
export * from "./textEditTool.vue?vue&type=script&lang=js"
import style0 from "./textEditTool.vue?vue&type=style&index=0&id=4e3b4ff4&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e3b4ff4')) {
      api.createRecord('4e3b4ff4', component.options)
    } else {
      api.reload('4e3b4ff4', component.options)
    }
    module.hot.accept("./textEditTool.vue?vue&type=template&id=4e3b4ff4", function () {
      api.rerender('4e3b4ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseTemplate/components/textEditTool.vue"
export default component.exports